import {createSlice} from "@reduxjs/toolkit";
import {initialPlanState} from "./initialPlanState";
import {isLengthValid, isWallWidthValid, isWidthValid} from "../../validation/form/planFormValidation";


export const planRootSlice = createSlice({
    name: 'planRoot',
    initialState: initialPlanState,
    reducers: {
        setDescription: (state, action) => {
            state.description = action.payload;
        },
        setLength: (state, action) => {
            if (Number.isInteger(action.payload) && isLengthValid(action.payload)) {
                state.length = action.payload;
            }
        },
        setWidth: (state, action) => {
            if (Number.isInteger(action.payload) && isWidthValid(action.payload)) {
                state.width = action.payload;
            }
        },
        setWallWidth: (state, action) => {
            if (Number.isInteger(action.payload) && isWallWidthValid(action.payload)) {
                state.wallWidth = action.payload;
            }
        }
    }
});

export const {
    setDescription,
    setLength,
    setWidth,
    setWallWidth
} = planRootSlice.actions;
